import React, { useCallback, useEffect, useRef, useState } from "react";
import { BiText } from "react-icons/bi";
import { MdOutlineDescription, MdBorderOuter } from "react-icons/md";
import { BsCardImage, BsConeStriped } from "react-icons/bs";
import { AiOutlineFileImage } from "react-icons/ai";
import { FaIcons } from "react-icons/fa";

import classes from "./Card2Page.module.css";
import Header from "../../stories/Header";
import PopOverItem from "../../stories/PopOverItem/PopOverItem";
import TextPopOverchildren from "../../stories/TextPopOverchildren/TextPopOverchildren";
import {
  auntySvg,
  smBlack1,
  smBlack2,
  smBlack3,
  smBlack4,
} from "../../assets/images/imagePath";
import {
  dataURLtoFile,
  resizeFile,
  smIcons,
  _description,
} from "../../handlers/helperFunctions";
import BgImagePopoverChildren from "../../stories/BgImagePopoverChildren";
import Button from "../../stories/Button/Button";
import Card2 from "../../stories/card2/Card2";
import SmIconsPopOverChildren from "../../stories/SmIconsPopOverChildren/SmIconsPopOverChildren";
import { useLocation } from "react-router-dom";
import ConfirmationModal from "../../stories/Confirmation/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { toJpeg } from "html-to-image";
import { toast } from "react-toastify";
import { Sleep } from "../../config/apiUrl";
import BodyLoader from "../../stories/BodyLoader/BodyLoader";
import { useDispatch } from "react-redux";
import { saveLocation } from "../../redux/common/commonSlice";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";

const Card2Page = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const navigate = useNavigate();
  const imageRef = useRef();
  const backImageRef = useRef();
  const [generatedImages, setGeneratedImages] = useState({
    front: null,
    back: null,
  });
  const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);

  const isFlatDesign = useLocation()?.state;
  // const isFlatDesign = false;
  const [mainBg, setMainBg] = useState(auntySvg);
  const [mainBgOpacity, setMainBgOpacity] = useState(0.5);

  const [outerBorder, setOuterBorder] = useState({
    isVisible: true,
    color: "#ff0009",
    gradientColor1: "#88273e",
    gradientColor2: "#095e79",
    gradient1Spread: "50",
    gradient2Spread: "50",
    outline: "#ff0009",
  });

  const [mainTitle, setMainTitle] = useState({
    text: "First main title",
    isVisible: true,
    color: "#000",
    gradientColor1: "#fdbb2d",
    gradientColor2: "#22c1c3",
    gradient1Spread: "25",
    gradient2Spread: "78",
    isFlat: isFlatDesign,
    outline: "#ff0009",
    fontStyle: null,
    fontWeight: null,
  });

  const [secondTitle, setSecondTitle] = useState({
    text: "Second main title",
    isVisible: true,
    color: "#000",
    gradientColor1: "#fdbb2d",
    gradientColor2: "#22c1c3",
    gradient1Spread: "25",
    gradient2Spread: "78",
    isFlat: isFlatDesign,
    outline: "#ff0009",
    fontStyle: null,
    fontWeight: null,
  });

  const [bottomTitle, setBottomTitle] = useState({
    text: "Bottom main title",
    isVisible: true,
    color: "#000",
    gradientColor1: "#fdbb2d",
    gradientColor2: "#22c1c3",
    gradient1Spread: "25",
    gradient2Spread: "78",
    isFlat: isFlatDesign,
    outline: "#ff0009",
    fontStyle: null,
    fontWeight: null,
  });

  const [description, setDescription] = useState({
    text: _description,
    isVisible: true,
    color: "#000",
    fontStyle: null,
    fontWeight: null,
  });

  const [bottomStrip, setBottomStrip] = useState({
    text: "01/02",
    isVisible: true,
    color: "#fff",
    bgColor: "#833ab4",
    outline: "#ff0009",
    fontStyle: null,
    fontWeight: null,
  });

  const [selectedSmIcons, setSelectedSmIcons] = useState([
    smBlack1,
    smBlack2,
    smBlack3,
    smBlack4,
  ]);

  const [cardBacksideImg, setCardBacksideImg] = useState(auntySvg);

  const [isFrontView, setIsFrontView] = useState(true);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  // handleGoForward
  const handleGoForward = async () => {
    setIsGeneratingPreview(true);
    const front = await handleGenerateForegroundImage();
    const back = await handleGenerateBackImage();

    setIsGeneratingPreview(false);

    if (!front || !back) return toast.warn("Back or front image is missing.");

    setIsGeneratingPreview(true);

    const _front = await resizeFile(front);
    const _back = await resizeFile(back);
    setIsGeneratingPreview(false);
    navigate("/detail-form", { state: { front: _front, back: _back } });
  };

  // generate image
  const handleGenerateImage = useCallback(async () => {
    if (imageRef.current) {
      await Sleep(1000);

      const code = await toJpeg(imageRef.current);
      let generatedFile = dataURLtoFile(code);

      if (!isFrontView)
        setGeneratedImages((p) => ({ ...p, front: generatedFile }));
      if (isFrontView)
        setGeneratedImages((p) => ({ ...p, back: generatedFile }));
    }
  }, [imageRef?.current]);

  // handleGenerateForegroundImage
  const handleGenerateForegroundImage = useCallback(async () => {
    if (imageRef.current) {
      await Sleep(1000);
      const code = await toJpeg(imageRef.current);
      let generatedFile = dataURLtoFile(code);

      setGeneratedImages((p) => ({ ...p, front: generatedFile }));
      return generatedFile;
    }
  }, [imageRef?.current]);

  // handleGenerateForegroundImage
  const handleGenerateBackImage = useCallback(async () => {
    if (backImageRef.current) {
      await Sleep(1000);
      const code = await toJpeg(backImageRef.current);
      let generatedFile = dataURLtoFile(code);
      setGeneratedImages((p) => ({ ...p, back: generatedFile }));
      return generatedFile;
    }
  }, [backImageRef?.current]);

  return (
    <div>
      <Header />
      {!isMobile && (
        <div className={classes?.splitterContainer}>
          <div className={classes?.leftSplit}>
            {/* Outer Border */}
            <PopOverItem
              Icon={MdBorderOuter}
              text={"Border & Colors"}
              identifier={"outer-border"}
              Component={
                <TextPopOverchildren
                  label={"Border"}
                  getter={outerBorder}
                  setter={setOuterBorder}
                  title={false}
                  gradient={true}
                  hideGradient={true} // needs to be corrected
                  showOutline={true}
                />
              }
            />

            {/* Main Img */}
            <PopOverItem
              Icon={BsCardImage}
              text={"Add Image"}
              identifier={"main-bg"}
              Component={
                <BgImagePopoverChildren
                  setMainBg={setMainBg}
                  opacity={mainBgOpacity}
                  setOpacity={setMainBgOpacity}
                />
              }
            />

            {/* Sm Icons */}
            <PopOverItem
              Icon={FaIcons}
              text={"Icons"}
              identifier={"sm-icons"}
              Component={
                <SmIconsPopOverChildren
                  icons={selectedSmIcons}
                  setIcons={setSelectedSmIcons}
                  galleryArray={smIcons}
                />
              }
            />
            {/* Main title */}
            <PopOverItem
              Icon={BiText}
              text={"Main Title"}
              identifier={"main-title"}
              Component={
                <TextPopOverchildren
                  label={"Main title"}
                  getter={mainTitle}
                  setter={setMainTitle}
                  gradient={true}
                  hideGradient={!mainTitle?.isFlat}
                  showOutline={true}
                />
              }
            />
            {/* Second title */}
            <PopOverItem
              Icon={BiText}
              text={"Second Title"}
              identifier={"second-title"}
              Component={
                <TextPopOverchildren
                  label={"Second title"}
                  getter={secondTitle}
                  setter={setSecondTitle}
                  gradient={true}
                  hideGradient={!secondTitle?.isFlat}
                  showOutline={true}
                />
              }
            />

            {/* Third title */}
            <PopOverItem
              Icon={BiText}
              text={"Bottom Title"}
              identifier={"Bottom-title"}
              Component={
                <TextPopOverchildren
                  label={"Bottom title"}
                  getter={bottomTitle}
                  setter={setBottomTitle}
                  gradient={true}
                  hideGradient={!bottomTitle?.isFlat}
                  showOutline={true}
                />
              }
            />
            {/* description */}
            <PopOverItem
              Icon={MdOutlineDescription}
              text={"Description"}
              identifier={"description"}
              Component={
                <TextPopOverchildren
                  isDescription={true}
                  label={"Description"}
                  getter={description}
                  setter={setDescription}
                />
              }
            />
            {/* bottomStrip */}
            <PopOverItem
              Icon={BsConeStriped}
              text={"Tab"}
              identifier={"strip"}
              Component={
                <TextPopOverchildren
                  label={"Tab"}
                  getter={bottomStrip}
                  setter={setBottomStrip}
                  backgroundColor={true}
                  showOutline={true}
                />
              }
            />

            {/* Card Backside */}
            <PopOverItem
              Icon={AiOutlineFileImage}
              text={"Card Back Image"}
              identifier={"back-img"}
              Component={
                <BgImagePopoverChildren setMainBg={setCardBacksideImg} />
              }
            />
          </div>
          <div className={classes?.middleSplit}>
            <Card2
              mainBg={mainBg}
              opacity={mainBgOpacity}
              outerBorder={outerBorder}
              mainTitle={mainTitle}
              secondTitle={secondTitle}
              bottomTitle={bottomTitle}
              description={description}
              bottomStrip={bottomStrip}
              selectedSmIcons={selectedSmIcons}
              cardBacksideImg={cardBacksideImg}
              isFrontView={isFrontView}
              imageRef={imageRef}
              backImageRef={backImageRef}
              generatingPreview={isGeneratingPreview}
            />

            <Button
              label={isFrontView ? "Show Back" : "Show Front"}
              className={classes?.viewtypeBtn}
              onClick={() => {
                // handleGenerateImage();
                setIsFrontView((p) => !p);
              }}
            />

            <Button
              label={"Finish Editing"}
              className={classes?.finishTypeBtn}
              onClick={() => setIsConfirmationModalOpen(true)}
            />
          </div>
          <div className={classes?.rightSplit}></div>
        </div>
      )}

      {isMobile && (
        <div className="mobile-rest">
          <p>This page is only supported on desktop devices.</p>
        </div>
      )}

      <ConfirmationModal
        show={isConfirmationModalOpen}
        setShow={setIsConfirmationModalOpen}
        subTitle={`Are you sure you are done editing? Once submitted, you can no longer make any more changes.`}
        onClick={handleGoForward}
      />

      {isGeneratingPreview && <BodyLoader title="Please Wait..." />}
    </div>
  );
};

export default Card2Page;
